module.exports = __webpack_public_path__ + "static/ChatSpace-c2b26718816e2d9b7c383b3cbb11f774.gif";